import { For } from 'solid-js';
import './TurnStack.css';

/** Oldest turn in the usual corner; newer turns stacked after it (max 3). */
export function TurnStack(props: { turns: readonly number[] }) {
  return (
    <span class="turn-stack">
      <For each={props.turns}>{(n) => <span class="turn-stack__mark">{n}</span>}</For>
    </span>
  );
}
